// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"PnlByInstrumentChartContainer_toggleContainer__1JnCS"};